import * as React from 'react'
import { SVGProps } from 'react'

const SvgHorizonBack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    viewBox='0 0 400.667 400.666'
    xmlSpace='preserve'
    {...props}
  >
    <linearGradient
      id='horizon_back_svg__a'
      gradientUnits='userSpaceOnUse'
      x1={200.667}
      y1={350.099}
      x2={200.667}
      y2={50.566}
    >
      <stop
        offset={0.5}
        style={{
          stopColor: '#503723'
        }}
      />
      <stop
        offset={0.5}
        style={{
          stopColor: '#558ebb'
        }}
      />
    </linearGradient>
    <circle
      fill='url(#horizon_back_svg__a)'
      cx={200.667}
      cy={200.333}
      r={149.767}
    />
  </svg>
)

export default SvgHorizonBack
